import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaCalendarAlt, FaUserTie, FaBullhorn, FaUserFriends, FaTag, FaFileExcel, FaSearch, FaRedo } from 'react-icons/fa';
import { getOpciones, getReporte, exportarExcel, agrupar } from '../../servicios/Reportes';
import './reportes.css';

const hoyStr = () => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const VACIO = { desde: hoyStr(), hasta: hoyStr(), asignador: '', campania: '', asesora: '', estado: '' };

export default function Reportes() {
    const [opciones, setOpciones] = useState({ asignadores: [], campanias: [], asesoras: [], estados: [] });
    const [filtros, setFiltros] = useState(VACIO);
    const [rows, setRows] = useState(null);
    const [cargando, setCargando] = useState(false);
    const [truncado, setTruncado] = useState(false);

    useEffect(() => { getOpciones().then(setOpciones).catch(() => {}); }, []);

    const set = (k) => (e) => setFiltros({ ...filtros, [k]: e.target.value });

    const generar = async () => {
        if (filtros.desde && filtros.hasta && filtros.desde > filtros.hasta) {
            toast.warn('La fecha "Desde" no puede ser mayor que "Hasta".'); return;
        }
        setCargando(true);
        try {
            const data = await getReporte(filtros);
            setRows(data.rows);
            setTruncado(!!data.truncado);
            if (data.truncado) toast.warn(`Se muestran los primeros ${data.limite.toLocaleString()} registros. Afina los filtros.`, { autoClose: 6000 });
            else if (data.rows.length === 0) toast.info('Sin resultados para esos filtros.');
        } catch (ex) { toast.error(ex.message); } finally { setCargando(false); }
    };

    const limpiar = () => { setFiltros(VACIO); setRows(null); setTruncado(false); };

    const porAsignador = rows ? agrupar(rows, 'asignador') : [];
    const porEstado = rows ? agrupar(rows, 'estado') : [];
    const ventasReales = rows ? rows.filter((r) => r.venta_real === 'Sí').length : 0;

    return (
        <div className="rp-wrap">
            <ToastContainer position="top-right" autoClose={4000} />
            <div className="rp-card">
                <h2 className="rp-title">Reporte de asignaciones</h2>
                <p className="rp-sub">Filtra por rango de fechas, asignador, campaña, asesora y estado. Exporta a Excel.</p>

                <div className="rp-filtros">
                    <label className="rp-f"><span><FaCalendarAlt /> Desde</span>
                        <input type="date" value={filtros.desde} onChange={set('desde')} /></label>
                    <label className="rp-f"><span><FaCalendarAlt /> Hasta</span>
                        <input type="date" value={filtros.hasta} onChange={set('hasta')} /></label>
                    <label className="rp-f"><span><FaUserTie /> Asignador</span>
                        <select value={filtros.asignador} onChange={set('asignador')}>
                            <option value="">Todos</option>
                            {opciones.asignadores.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select></label>
                    <label className="rp-f"><span><FaBullhorn /> Campaña</span>
                        <select value={filtros.campania} onChange={set('campania')}>
                            <option value="">Todas</option>
                            {opciones.campanias.map((c) => <option key={c} value={c}>{c}</option>)}
                        </select></label>
                    <label className="rp-f"><span><FaUserFriends /> Asesora</span>
                        <select value={filtros.asesora} onChange={set('asesora')}>
                            <option value="">Todas</option>
                            {opciones.asesoras.map((a) => <option key={a.id} value={a.id}>{a.nombre}</option>)}
                        </select></label>
                    <label className="rp-f"><span><FaTag /> Estado</span>
                        <select value={filtros.estado} onChange={set('estado')}>
                            <option value="">Todos</option>
                            {opciones.estados.map((e) => <option key={e} value={e}>{e}</option>)}
                        </select></label>
                </div>

                <div className="rp-acciones">
                    <button className="rp-btn" onClick={generar} disabled={cargando}>
                        <FaSearch /> {cargando ? 'Generando…' : 'Generar reporte'}
                    </button>
                    <button className="rp-btn rp-btn--sec" onClick={limpiar} disabled={cargando}><FaRedo /> Limpiar</button>
                    {rows && rows.length > 0 && (
                        <button className="rp-btn rp-btn--excel" onClick={() => exportarExcel(rows)}><FaFileExcel /> Exportar Excel</button>
                    )}
                </div>

                {rows && (
                    <div className="rp-resultado">
                        <div className="rp-resumen">
                            <div className="rp-total"><span>Total asignados</span><strong>{rows.length.toLocaleString()}{truncado ? '+' : ''}</strong></div>
                            <div className="rp-total rp-total--ventas"><span>Ventas reales (Activa)</span><strong>{ventasReales.toLocaleString()}</strong></div>
                            <div className="rp-desglose">
                                <div className="rp-deslista">
                                    <h4>Por asignador</h4>
                                    {porAsignador.map(([k, n]) => <div key={k} className="rp-desitem"><span>{k}</span><b>{n}</b></div>)}
                                </div>
                                <div className="rp-deslista">
                                    <h4>Por estado</h4>
                                    {porEstado.map(([k, n]) => <div key={k} className="rp-desitem"><span>{k}</span><b>{n}</b></div>)}
                                </div>
                            </div>
                        </div>

                        <div className="rp-tabla-wrap">
                            <table className="rp-tabla">
                                <thead>
                                    <tr><th>Número</th><th>Fecha</th><th>Hora</th><th>Asignador</th><th>Asesora</th><th>Campaña</th><th>Estado</th><th>Venta real</th><th>Tipo</th></tr>
                                </thead>
                                <tbody>
                                    {rows.map((r, i) => (
                                        <tr key={r.numero + '-' + i}>
                                            <td>{r.numero}</td><td>{r.fecha}</td><td>{r.hora}</td>
                                            <td>{r.asignador}</td><td>{r.asesora}</td><td>{r.campania}</td>
                                            <td>{r.estado}</td>
                                            <td><span className={`lead-badge ${r.venta_real === 'Sí' ? 'lead-badge--success' : 'lead-badge--default'}`}>{r.venta_real || 'No'}</span></td>
                                            <td>{r.tipo}</td>
                                        </tr>
                                    ))}
                                    {rows.length === 0 && <tr><td colSpan={8} className="rp-vacio">Sin resultados</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
